module.exports = __webpack_public_path__ + "static/media/caution_outline.676058de.svg";